// NČLP is the Czech national code list of laboratory items, so everything built
// around it (the NČLP analysis and the complete laboratory audit among the AI
// services, the catalogue link) is shown in the Czech version only. The root
// path resolves to Czech, hence the empty check.
export const showsNclp = (language?: string): boolean => !language || language.startsWith('cs');
